import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import { routerShape } from 'react-router/lib/PropTypes'

/*
 This renders a button[type='submit'] element, which submits a redux-form form when clicked, and
 then moves to the location specified in `to`.
 Pass it the form's handleSubmit function and the location as props, and it will take care of the rest.
*/
class SubmitLink extends React.Component {
  static propTypes = {
    to: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    router: routerShape.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    text: PropTypes.string,
    value: PropTypes.string,
    dataNemo: PropTypes.string,
  }

  render() {
    const propsToPass = { ...this.props }
    delete propsToPass.handleSubmit
    delete propsToPass.router
    delete propsToPass.text
    delete propsToPass.to
    delete propsToPass.params
    delete propsToPass.location
    delete propsToPass.routes

    return (
      <button
        {...propsToPass}
        data-nemo={this.props.dataNemo}
        onClick={this.props.handleSubmit(() => {
          // if we got here, validation is ok
          this.props.router.push(this.props.to)
        })}
      >
        {this.props.text || this.props.value}
      </button>
    )
  }
}

export default withRouter(SubmitLink)
